import React from 'react';
import PropTypes from 'prop-types';

import Api from '../../Api';
import LightBox from '../../components/LightBox';
import Processing from '../../components/Processing';
import RetailerProduct from '../ProductModal';
import CategoryBar from '../../components/CategoryBar';

import Brand from './brand';
import Product from './product';
import {CATEGORY_FILTERS} from '../../consts';

import './style.less';
import BreadCrumb from "../../components/BreadCrumb/index";

let topTreshold = 20;

export default class Collection extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    Api.Utils.bindThis(
      this,
      [
        'setcollectionsValue',
        'productList',
        'closeProductModal',
        'productModal',
        'openProductModal',
        'save',
        'setProductActive',
        'addToBag',
        'onCategory',
        'onBreadCrumb'
      ]
    );

    this.state = {
      collections: null,
      activeCollection: null,
      productGroups: null,
      brand: null,
      productToken: null,
      closestBrandRetailer: null,
      scrollTop: 0,
      addingToBag: false,
      user: null
    };
  }

  componentWillMount() {
    Api.getProductCollections(true)
      .then(
        collections => {
          this.setcollectionsValue(collections);
        },
        error => {
          console.error(error);
        }
      );

    Api.getCategories(true)
      .then(
        categories => {
          this.setState({
            categories
          });
        },
        error => {
          console.error(error);
        }
      );

    Api.getUser(true)
      .then(user => this.setState({user}));

    Api.startListen(this, 'user', Api.cache.eventTypes.USER_CHANGED);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.USER_CHANGED);
  }

  setcollectionsValue(collections) {
    let activeCollection = collections.product_collections.find(
      collection => {
        return collection.token === this.props.params.collectionToken;
      }
    );

    // Setup brand and product groups for properly grouping product options
    let brand = null;
    let productGroups = null;
    if (activeCollection) {
      if (activeCollection.items && activeCollection.items.length > 0) {
        brand = collections.brands[activeCollection.items[0].brand_token];
      }

      productGroups = {};
      activeCollection.items.forEach(
        product => {
          if (Object.keys(productGroups).indexOf(product.product_token) < 0) {
            productGroups[product.product_token] = {
              active: true,
              product: collections.products[product.product_token],
              products: []
            };
          }

          productGroups[product.product_token].products.push(product);
        }
      )
    }

    this.setState({
      activeCollection,
      collections,
      brand,
      productGroups,
      closestBrandRetailer: null
    });

    if (brand && brand.token) {
      Api.getClosestBrandRetailer(brand.token)
        .then(
          closestBrandRetailer => {
            this.setState({closestBrandRetailer});
          }
        );
    }
  }

  setProductActive(productToken, active) {
    let productGroups = Api.Utils.clone(this.state.productGroups, true);
    let currentGroup = productGroups[productToken];

    if (!currentGroup) {
      console.error("Cannot find group: " + productToken);
      return;
    }

    if (currentGroup.active === active) return;

    currentGroup.active = active;
    this.setState({productGroups});
  }

  productList() {
    if (!this.state.productGroups) return null;

    let productKeys = Object.keys(this.state.productGroups);

    let products = productKeys
      .map(
        productKey => {
          return this.state.productGroups[productKey]
        }
      )
      .map(
        productGroup => {
          let product = this.state.collections.products[productGroup.products[0].product_token];
          return (
            <Product
              key={product.token}
              product={product}
              collectionOptions={productGroup.products}
              onEdit={this.openProductModal}
              setActive={this.setProductActive}
            />
          );
        }
      );

    return products;
  }

  closeProductModal() {
    this.setState({productToken: null});
  }

  openProductModal(productToken) {
    this.setState({productToken: productToken});
  }

  productModal() {
    if (!this.state.productToken) return null;

    let productGroup = this.state.productGroups[this.state.productToken];
    let product = this.state.collections.products[this.state.productToken];
    let batchCount = product.options[0].unit_multiplier;

    let defaultSelection = productGroup.products.map(
      group => {
        let batches = group.quantity / batchCount;
        if (!batches) batches = 1;

        return {
          option: group.product_option_token,
          batches: batches
        }
      }
    );

    return (
      <LightBox onClose={this.closeProductModal}>
        <RetailerProduct
          productToken={this.state.productToken}
          retailerToken={this.props.params.retailerToken}
          buttonText="Save"
          defaultSelection={defaultSelection}
          onSave={this.save}
          onCancel={this.closeProductModal}
          isEmployee={this.state.user && this.state.user.is_employee}
        />
      </LightBox>
    );
  }

  save(productToken, selection) {
    let product = this.state.collections.products[productToken];
    let batchCount = product.options[0].unit_multiplier;

    let newSelection = selection.map(
      select => {
        return {
          brand_token: product.brand_token,
          product_option_token: select.option,
          product_token: product.token,
          quantity: select.batches * batchCount,
        }
      }
    );

    let newProductGroup = Api.Utils.clone(this.state.productGroups, true);
    newProductGroup[this.state.productToken].products = newSelection;
    this.setState({productGroups: newProductGroup});

    this.closeProductModal();
  }

  addToBag() {
    let cartList = [];
    Object.keys(this.state.productGroups)
      .map(productToken => {
        return this.state.productGroups[productToken];
      })
      .forEach(productGroup => {
        if (!productGroup.active) return;

        productGroup.products.forEach(productGroupItem => {
          let cartItem = {
            brand_token: productGroupItem.brand_token,
            product_token: productGroupItem.product_token,
            product_option_token: productGroupItem.product_option_token,
            price_cents: productGroup.product.options[0].wholesale_price_cents,
            quantity: productGroupItem.quantity
          };
          cartList.push(cartItem);
        });
      });

    this.setState({
      addingToBag: true
    });

    return Api.addToCart(cartList)
      .then(
        response => {
          this.context.router.push(`/retailer/${this.props.params.retailerToken}`);
          return response;
        },
        error => {
          console.error("Cannot add collection to bag.");
          console.error(error);
          this.setState({
            addingToBag: false
          });
          return error;
        }
      );
  }

  onBreadCrumb(_, position) {
    // only home is relevant
    if (position !== 0) {
      return;
    }
    this.context.router.push(`/retailer/${this.props.params.retailerToken}`);
  }

  onCategory(category, subcategory, filter) {
    let categoryString = '';
    if (category) categoryString += category;
    if (subcategory) categoryString += `+${subcategory}`;
    if (filter) categoryString += `:${filter.name}`;

    if (categoryString) categoryString = `/category/${categoryString}`;

    this.context.router.push(`/retailer/${this.props.params.retailerToken}${categoryString}`);
  }

  render() {
    if (!this.state.collections || !this.state.categories) return <div className="retailer-loading-wrapper">
      <Processing />
    </div>;
    if (!this.state.activeCollection) return <div>Invalid collection</div>;

    let numberOfItems = 0;
    let valueOfItems = 0;
    let brandList = [];

    Object.keys(this.state.productGroups)
      .map(
        productKey => {
          return this.state.productGroups[productKey]
        }
      )
      .forEach(productGroup => {
        let brandToken = productGroup.product.brand_token;
        if (brandList.indexOf(brandToken) < 0) {
          brandList.push(brandToken);
        }

        if (productGroup.active) {
          productGroup.products.forEach(collectionProduct => {
            numberOfItems += collectionProduct.quantity;
            valueOfItems += productGroup.product.options[0].wholesale_price_cents * collectionProduct.quantity;
          });
        }
      });

    let url = '';
    if (brandList.length === 1) {
      url = this.state.brand.url.replace(/https?:\/\/([^\/]*)\/?/, '$1');
    }

    let classNames = ['collection-component'];
    if (this.state.scrollTop > topTreshold) classNames.push('scrolled');

    return (
      <div className={classNames.join(' ')}>
        <CategoryBar categories={this.state.categories}
                     onSelect={this.onCategory}
                     filters={CATEGORY_FILTERS}/>
        <Brand
          title={this.state.activeCollection.name}
          brand={this.state.brand}
          url={url}
          description={this.state.activeCollection.description}
          closestBrandRetailer={this.state.closestBrandRetailer}
          count={numberOfItems}
          cost={valueOfItems}
          loading={this.state.addingToBag}
          addToBag={this.addToBag}
        />
        <BreadCrumb primary={this.state.activeCollection.name} onSelect={this.onBreadCrumb}/>
        <div className="product-list">
          {this.productList()}
        </div>
        {this.productModal()}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/collection/index.js
 **/